import React from 'react'
import { Fade } from 'react-awesome-reveal'
import Scrollbtn from '../button/Scrollbtn'
import ColorTheme from '../theme/ColorTheme'

function AppFooter() {

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <>
            <Scrollbtn />
            <footer className="padding-t-50 bg-market">
                <img src="assets/img/theme/footer-theme-1.png" alt="footer-theme" className="footer-theme-1" />
                <img src="assets/img/theme/footer-theme-3.png" alt="footer-theme" className="footer-theme-3" />
                <img src="assets/img/theme/footer-theme-4.png" alt="footer-theme" className="footer-theme-4" />
                <img src="assets/img/theme/footer-theme-3.png" alt="footer-theme" className="footer-theme-5" />
                <div className="container">
                    <Fade triggerOnce duration={1500} direction='up' className="row border-bottom">
                        <>
                            <div className="col-lg-6 col-sm-12">
                                <div className="zx-app-fotter-banner">
                                    <h2>Lets talk.</h2>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <div className="subscribe">
                                    <h4>Subscribe Our Newsletter</h4>
                                    <p>
                                        Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                                        Explicabo, unde!
                                    </p>
                                </div>
                                <form className="zx-app-footer-control" role="search">
                                    <input className="form-control shadow-none" type="search" placeholder="Your email Address"
                                        aria-label="Search" />
                                    <span className="fa fa-paper-plane" aria-hidden="true"></span>
                                </form>
                            </div>
                        </>
                    </Fade>
                    <div className="row padding-tb-100 spacing-991">
                        <Fade triggerOnce duration={1000} direction='up' className="col-lg-5 col-md-6 col-sm-12">
                            <>
                                <div className="zx-app-footer">
                                    <img src="assets/img/logo/logo.png" alt="logo" className="white-mode" />
                                    <img src="assets/img/logo/logo-footer.png" alt="footer" className="dark-mode" />
                                </div>
                                <ul className="footer-main">
                                    <li>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod
                                            eos enim pariatur officia minima odio corrupti quaerat ex ipsa
                                            consequuntur.
                                        </p>
                                    </li>
                                    <li>
                                        <a onClick={handleSubmit} href="/"><img src="assets/img/logo/facebook.png" alt="facebook" /></a>
                                        <a onClick={handleSubmit} href="/"><img src="assets/img/logo/twitter.png" alt="twitter" /></a>
                                        <a onClick={handleSubmit} href="/"><img src="assets/img/logo/instagram.png" alt="instagram" /></a>
                                        <a onClick={handleSubmit} href="/"><img src="assets/img/logo/linkedin.png" alt="linkedin" /></a>
                                    </li>
                                </ul>
                            </>
                        </Fade>
                        <Fade triggerOnce duration={1500} direction='up' className="col-lg-3 col-md-6 col-sm-12">
                            <>
                                <ul className="footer-main">
                                    <li>
                                        <h4>Contacts information</h4>
                                    </li>
                                    <li>
                                        <p>9158 Rock Maple Lane Harlin gen,
                                            TX 78552</p>
                                    </li>
                                    <li className="zx-footer-link">
                                        <h6>
                                            <a onClick={handleSubmit} href="/">examle@ec-email.com</a>
                                        </h6>
                                    </li>
                                    <li className="zx-footer-link">
                                        <h6>
                                            <a onClick={handleSubmit} href="/">+91 (123) (4567) (890)</a>
                                        </h6>
                                    </li>
                                </ul>
                            </>
                        </Fade>
                        <Fade triggerOnce duration={2000} direction='up' className="col-lg-4 col-sm-12">
                            <>
                                <ul className="footer-main">
                                    <li>
                                        <h4>Support & Downloads</h4>
                                    </li>
                                    <li>
                                        <p>
                                            Lorem ipsum dolor sit, amet consectetur elit. Veniam dolore
                                            nobis rerum accusantium?
                                        </p>
                                    </li>
                                    <li className="zx-app-image-store">
                                        <img src="assets/img/landing/app-store.png" alt="app-store" />
                                        <img src="assets/img/landing/google-pay.png" alt="google-pay" />
                                    </li>
                                </ul>
                            </>
                        </Fade>
                    </div>
                    <div className="row">
                        <div className="col-12 border-top">
                            <div className="zx-app-last-footer">
                                <p>
                                    copyright @
                                    <a onClick={handleSubmit} href="/"><span className="text-color"> Zorox </span></a>
                                    all rights reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <ColorTheme />
        </>
    )
}

export default AppFooter
